$.fn.slider = function(config) {
    const options = $.extend({
        breakpoints: [],
        auto : true,
        pauseTimer: 5000,
        elementSelector: '.el',
        enableSwipe: true,
        swipeHorizontal: true,
        afterMakeSlide: function() {

        }
    }, config);

    return this.each(function() {
        const $list = $(this);
        if (!$list.length) return;

        let time = null;
        let slidesCount = 0;
        let $dots = $list.next(".dots");
        let countDots = 0;
        let elemsPerTab = 10;
        let currentSlide = 0;

        function makeSlider() {
            elemsPerTab = 12;
            currentSlide = 0;
            slidesCount = 0;
            if (options.breakpoints.length) {
                for (let i = 0; i < options.breakpoints.length; i++) {
                    if (window.innerWidth < options.breakpoints[i].width) {
                        elemsPerTab = options.breakpoints[i].count;
                        break;
                    }
                }
            }

            const $elements = $list.find(options.elementSelector);
            $list.html("");
            $list.append($elements);
            $list.addClass("slider");

            for (let i = 0; i < $elements.length; i += elemsPerTab) {
                $elements.slice(i, i + elemsPerTab).wrapAll("<div class='slider-list-slide'></div>");
                slidesCount++;
            }

            countDots = $list.find(".slider-list-slide").length;

            $dots.empty();

            if (slidesCount > 1) {
                for (let i = 0; i < slidesCount; i++) {
                    $dots.append('<a href="#" class="dots-link">' + i + '</a>');
                }
            }

            options.afterMakeSlide();
            showSlide(0);
        }

        function nextSlide() {
            currentSlide++;
            if (currentSlide > slidesCount - 1) {
                currentSlide = 0;
            }
            showSlide(currentSlide);
        }

        function prevSlide() {
            currentSlide--;
            if (currentSlide < 0) {
                currentSlide = slidesCount - 1;
            }
            showSlide(currentSlide);
        }

        function showSlide(slide) {
            currentSlide = slide;
            const $a = $dots.find("a");
            $a.removeClass("is-active");
            $a.eq(slide).addClass("is-active");
            $list.children().removeClass("is-show");
            $list.children().eq(slide).addClass("is-show");

            if (options.auto) slidePause();
        }

        function slidePause() {
            clearTimeout(time);
            time = setTimeout(function() {
                nextSlide();
            }, options.pauseTimer)
        }

        $dots.on("click", "a", function(e) {
            e.preventDefault();
            currentSlide = $(this).parent().children().index($(this));
            if (options.auto) showSlide(currentSlide);
        })

        if (options.auto) {
            $list.on("mouseover", "a", function(e) {
                e.preventDefault();
                clearTimeout(time);
            })

            $list.on("mouseout", "a", function(e) {
                e.preventDefault();
                clearTimeout(time);
                slidePause();
            })
        }

        makeSlider();
        showSlide(currentSlide);

        if (options.enableSwipe) {
            const mc = new Hammer($list.get(0));
            const events = options.swipeHorizontal ? "panleft panright" : "panup pandown";

            let direction = "prev";

            mc.on(events, function(ev) {
                if (options.swipeHorizontal) {
                    direction = ev.type === "panleft" ? "next" : "prev";
                } else {
                    direction = ev.type === "panup" ? "next" : "prev";
                }
            });

            mc.on("panend", function(ev) {
                if (direction === "next") {
                    nextSlide();
                } else {
                    prevSlide();
                }
            });
        }

        $(window).on("load resize", function() {
            makeSlider();
            showSlide(currentSlide);
        });
    });
}
